import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { observer } from "mobx-react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router";
import { portalStore } from "../../../Stores/portal";
import { AccountingTransactions } from "./Accounting/transactions";
import { Pricings } from "./Accounting/pricings";
import { AccountingDashboard } from "./Accounting/dashboard";
import { AccountingSettings } from "./Accounting/settings";

const _Accounting: React.FC = () => {
  const nav = useNavigate();
  return (
    <Container fluid>
      <Row
        style={{
          height: portalStore.portalHeight,
          overflow: "hidden",
          padding: "",
        }}
      >
        <Col lg={3} md={3}>
          <SideMenu />
        </Col>
        <Col lg={9} md={9}>
          <_Sub />
        </Col>
      </Row>
    </Container>
  );
};

const _Sub: React.FC = () => {
  const { section } = useParams();
  if (section === undefined) {
    return <AccountingDashboard />;
  }
  switch (section) {
    case "pricing":
      return <Pricings />;

    case "transactions":
      return <AccountingTransactions />;

    case "settings":
      return <AccountingSettings />;

    default:
      return <></>;
  }
};

const SideMenu: React.FC = () => {
  const nav = useNavigate();
  const { section } = useParams();
  return (
    <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
      <Divider />
      <nav aria-label="secondary mailbox folders">
        <List>
          <ListItem disablePadding style={{ fontWeight: "bold" }}>
            <ListItemButton onClick={() => nav("/accounting/")}>
              <ListItemText
                primary="Overview"
                style={{
                  color: section == undefined ? "tomato" : "black",
                  fontWeight: "bolder",
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              component="a"
              href="/accounting/transactions"
              onClick={(e) => {
                e.preventDefault();
                nav("/accounting/transactions");
              }}
            >
              <ListItemText
                primary="Transactions"
                style={{
                  color:
                    section && section === "transactions" ? "tomato" : "black",
                  fontWeight: "bolder",
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => nav("/accounting/pricing")}>
              <ListItemText
                primary="Pricing"
                style={{
                  color: section && section === "pricing" ? "tomato" : "black",
                  fontWeight: "bolder",
                }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={() => nav("/accounting/settings")}>
              <ListItemText
                primary="Settings"
                style={{
                  color: section && section === "settings" ? "tomato" : "black",
                  fontWeight: "bolder",
                }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </nav>
    </Box>
  );
};

const Accounting = observer(_Accounting);

export { Accounting };
